<template>
    <main class="container_rendu_mobile" id="RenduMobile">
        <!--section top -->
        <section class="container_rendu_mobile__section_top">
            <!-- article top -->
            <article class="container_rendu_mobile__section_top__article_top">
                <aside class="container_rendu_mobile__section_top__article_top__aside">
                    <div class="container_rendu_mobile__section_top__article_top__aside__div">
                        <h1 class="container_rendu_mobile__section_top__article_top__aside__div__h1">
                            Rendu réaliste
                        </h1>
                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_rendu_mobile__section_top__article_bottom">
                <aside class="container_rendu_mobile__section_top__article_bottom__aside">
                    <div class="container_rendu_mobile__section_top__article_bottom__aside__div_top">
                        <img src="@/assets/27.png" alt="rendu réaliste"
                            class="container_rendu_mobile__section_top__article_bottom__aside__div_top__img">
                    </div>
                    <!-- div bottom -->
                    <div class="container_rendu_mobile__section_top__article_bottom__aside__div_bottom">
                        <p class="container_rendu_mobile__section_top__article_bottom__aside__div_bottom__p">
                            Je réalise également des rendus réalistes. Ces derniers peuvent prendre beaucoup de temps et
                            nécessite beaucoup de ressources.
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
            </article>
        </section>
        <!-- section bottom-->
        <section class="container_rendu_mobile__section_bottom">
            <article class="container_rendu_mobile__section_bottom__article_top">
                <aside class="container_rendu_mobile__section_bottom__article_top__aside_top">
                    <div class="container_rendu_mobile__section_bottom__article_top__aside_top__div_title">
                        <h1 class="container_rendu_mobile__section_bottom__article_top__aside_top__div_title__h1">
                            Tarif
                        </h1>
                    </div>
                    <!-- div -->
                    <div class="container_rendu_mobile__section_bottom__article_top__aside_top__div_text">
                        <p class="container_rendu_mobile__section_bottom__article_top__aside_top__div_text__p">
                            - Rendu réaliste : 800€ <br>
                            - Modélisation 3D : 80€/j <br>
                            - Réalisation rapide <br>
                        </p>
                        <p class="container_rendu_mobile__section_bottom__article_top__aside_top__div_text__prix">
                            Prix total : 800 €
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_rendu_mobile__section_bottom__article_top__aside_bottom">
                    <div class="container_rendu_mobile__section_bottom__article_top__aside_bottom__div_left">
                        <router-link
                            class="container_rendu_mobile__section_bottom__article_top__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_rendu_mobile__section_bottom__article_top__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                </aside>
            </article>
            <!-- article bottom-->
            <article class="container_rendu_mobile__section_bottom__article_bottom">
                <aside class="container_rendu_mobile__section_bottom__article_bottom__aside_left">
                    <router-link class="container_rendu_mobile__section_bottom__article_bottom__aside_left__router-link"
                        to="/mise-en-plan">
                        <button
                            class="container_rendu_mobile__section_bottom__article_bottom__aside_left__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back"  id="div_button">
                                <img src="@/assets/back.png" alt="back"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
                <!-- aside right -->
                <aside class="container_rendu_mobile__section_bottom__article_bottom__aside_right">
                    <router-link
                        class="container_rendu_mobile__section_bottom__article_bottom__aside_right__router-link"
                        to="/conception">
                        <button
                            class="container_rendu_mobile__section_bottom__article_bottom__aside_right__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next"  id="div_button">
                                <img src="@/assets/next.png" alt="next"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'RenduMobile',
}
</script>

<style  lang=scss>
router-link {
    display: block;
}

@import "@/style/components/Services/Rendu-realiste/RenduMobile.scss";

@media screen and(min-width: 926px) {
    #RenduMobile {
        display: none;
    }
}
</style>